import AuthService from '../../../services/authService';
import UserService from '../../user/services/userService';
import WelcomeController from './welcomeController';

import _ from './welcome.scss';

const Welcome = {
    template: require('./welcomeView.html'),
    controller: WelcomeController
};

export default angular.module('app.welcome', [])
    .component('welcome', Welcome)
    .service("AuthService", AuthService)
    .service("UserService", UserService)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/login/welcome/welcomeComponent.js